import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=52a79930&"
import script from "./cascader.vue?vue&type=script&lang=ts&"
export * from "./cascader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports